import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { LabourActionTypes } from "./Labour.type";

export function* fetchAllLabour(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/labour?project_id=${action.payload}`
    );
    yield put({
      type: LabourActionTypes.FETCH_ALL_LABOUR_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: LabourActionTypes.FETCH_ALL_LABOUR_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllLabour() {
  yield takeLatest(LabourActionTypes.FETCH_ALL_LABOUR, fetchAllLabour);
}
